module.exports = require("@fregante/relaxed-json");